import { useEffect } from 'react';
import { setFormData } from '../state/formsReducer';
import debounce from 'lodash.debounce';
import { useDispatch } from 'react-redux';

const saveForm = debounce((formikProps, name, dispatch) => {
  dispatch(setFormData({
    name, data: {
      dirty: formikProps.dirty,
      isValid: formikProps.isValid,
      values: formikProps.values,
    }
  }));
}, 300);

export const usePersist = (formik, name) => {
  const dispatch = useDispatch();
  
  useEffect(() => {
    saveForm(formik, name, dispatch);
  }, [dispatch, formik, name]);
};
